// deepLinkPriceMismatch.reducer.ts
import * as OutboundFlightInformationActions from '../actions/outbound-flight-information.indra.actions';
import * as OutboundFlightInformationState from '../states/outbound-flight-information.indra.state';

export class State extends OutboundFlightInformationState.OutboundFlightState { }

export function outboundFlightInformationReducer(state = OutboundFlightInformationState.initialState, action: OutboundFlightInformationActions.Actions): OutboundFlightInformationState.OutboundFlightState {
  switch (action.type) {
    case OutboundFlightInformationActions.ActionTypes.PUT_OUTBOUND_FLIGHT_INFORMATION:
        state = Object.assign({}, state, {
            stage: action.stage,
            flight: action.payload
        });
        return state;
    case OutboundFlightInformationActions.ActionTypes.RESET_OUTBOUND_FLIGHT_INFORMATION:
      return OutboundFlightInformationState.initialState;
    default:
      return state;
  }
}

export const getOutboundFlightInformation = (state: OutboundFlightInformationState.OutboundFlightState) => { if (state && state.flight) return state};
